require('../vendor/html5up-alpha/index.js');
require('./mavo.js');



// WEBPACK FOOTER //
// ./assets/js/index.js